var $ = require('jquery');
import inview from 'jquery-inview/jquery.inview';

$(window).ready(function () {
    handlePipeline();
});

$(window).resize(function () {

    if ($(window).width() > 1023) {
        $('.top-icon').css('bottom', $('.section-pipeline__item:last').outerHeight() - 80 + 'px');
    } else {
        $('.top-icon').css('bottom', -50);
    }
    handlePipeline();
});

function handlePipeline() {

    $('.section-pipeline__item').each(function () {
        $('.bar-wrap').on("inview", function (t, n) {
            n && $(this).children(".bar").addClass("animated");
        })
    });

    $('.section-pipeline__item--plus').on('click', function () {
        $(this).children('.plus-line.plus-line--1').toggleClass('active');
        $(this).children('.plus-line.plus-line--2').toggleClass('open');
        $(this).parents('.section-pipeline__item--content').siblings('.section-pipeline__item--description').toggleClass('open');


        var counter = 0;
        $('.section-pipeline__item--description').each(function () {
            if ($(this).hasClass('open')) {
                counter += 1;
            }
        });
        if (counter === 3) {
            $('.top-icon').addClass('show');
            if ($(window).width() > 1023) {
                $('.top-icon').css('bottom', $('.section-pipeline__item:last').outerHeight() - 80 + 'px');
            } else {
                $('.top-icon').css('bottom', -50);
            }
        } else {
            $('.top-icon').removeClass('show');
        }

    });

    $('.top-icon').on('click', function () {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
        setTimeout(function () {
            $('.section-pipeline__item--plus').children('.plus-line.plus-line--1').addClass('active');
            $('.section-pipeline__item--plus').children('.plus-line.plus-line--2').removeClass('open');
            $('.section-pipeline__item--plus').parents('.section-pipeline__item--content').siblings('.section-pipeline__item--description').toggleClass('open');
        }, 400);
        $(this).removeClass('show');
    });
}